<template>
  <div class="add-product-modal">
    <v-dialog v-model="dialog" :fullscreen="maximize" :max-width="maxWidth" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-0': breakpointXs }">
        <v-card-title
          class="add-product-modal__head"
          :class="{ 'justify-space-between': !breakpointXs, 'justify-center': breakpointXs }"
        >
          <div class="add-product-modal__head--title fs-25 fw-600">Add New Product</div>
          <div class="justify-end">
            <v-btn icon v-if="!breakpointXs" v-show="maximize" @click="maximize = false">
              <v-icon>fas fa-window-minimize</v-icon>
            </v-btn>
            <v-btn icon v-if="!breakpointXs" v-show="!maximize" @click="maximize = true">
              <v-icon>fas fa-window-maximize</v-icon>
            </v-btn>
            <v-btn icon @click="closeDialog">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pt-5 add-product-modal__tab" :class="{ 'pa-2': breakpointXs }">
          <v-tabs v-model="tab">
            <v-tab v-for="item in tabHeaders" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="add-product-modal__tab-items">
            <v-tab-item class="add-product-modal__tab-items__products">
              <!-- 0th position -->
              <ProductsTab
                @selected-exim-scheme="selectedEximScheme"
                @close-dialog="closeDialog"
                @change-tab="changeTab"
                :itemSrNo="itemSrNo"
                :invoiceSrNo="invoiceSrNo"
                @item-saved="productItemSaved = true"
              />
            </v-tab-item>
            <v-tab-item class="add-product-modal__tab-items__main" v-if="isTabDisplay()">
              <!-- 1st position -->
              <MainTab
                @selected-exim-scheme="selectedEximScheme"
                @change-tab="changeTab"
                :itemSrNo="itemSrNo"
                :invoiceSrNo="invoiceSrNo"
              />
            </v-tab-item>
            <span v-if="isTabDisplay()">
              <v-tab-item class="add-product-modal__tab-items" v-for="scheme in applicableSchemes" :key="scheme.id">
                <!-- 2nd position -->
                <DrawbackTab
                  @change-tab="changeTab"
                  :itemSrNo="itemSrNo"
                  :invoiceSrNo="invoiceSrNo"
                  v-if="scheme.title === 'DBK'"
                />
                <LicenseTab
                  :schemeAbbreviation="scheme.title"
                  @change-tab="changeTab"
                  v-else
                  :invoiceSrNo="invoiceSrNo"
                  :itemSrNo="itemSrNo"
                />
              </v-tab-item>
            </span>
            <!-- <v-tab-item class="add-product-modal__tab-items__cess" v-if="isTabDisplay()">
              <CESSTab @change-tab="changeTab" :itemSrNo="itemSrNo" />
            </v-tab-item> -->
            <!-- <v-tab-item class="add-product-modal__tab-items__quota">
              <QuotaTab @change-tab="changeTab" :itemSrNo="itemSrNo" />
            </v-tab-item> -->
            <v-tab-item class="add-product-modal__tab-items__ar4" v-if="isTabDisplay()">
              <AR4DetailsTab @change-tab="changeTab" :invoiceSrNo="invoiceSrNo" :itemSrNo="itemSrNo" />
            </v-tab-item>
            <!-- <v-tab-item class="add-product-modal__tab-items__re-export" v-if="isTabDisplay()">
              <ReExportTab @change-tab="changeTab" :invoiceSrNo="invoiceSrNo" :itemSrNo="itemSrNo" />
            </v-tab-item> -->
            <v-tab-item class="add-product-modal__tab-items__other" v-if="isTabDisplay()">
              <OtherInfoTab
                @close-dialog="closeDialog"
                @change-tab="changeTab"
                :invoiceSrNo="invoiceSrNo"
                :itemSrNo="itemSrNo"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ProductsTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/ProductsTab";
import MainTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/MainTab";
import LicenseTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/LicenseTab";
import DrawbackTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/DrawbackTab";
// import CESSTab from "./CESSTab";
// import QuotaTab from "./QuotaTab";
import AR4DetailsTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/AR4DetailsTab";
// import ReExportTab from "./ReExportTab";
import OtherInfoTab from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/OtherInfoTab";
// import { SET_SCHEME_ABBREVIATION } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "AddProductModal",
  components: {
    ProductsTab,
    MainTab,
    LicenseTab,
    DrawbackTab,
    // CESSTab,
    // QuotaTab,
    AR4DetailsTab,
    // ReExportTab,
    OtherInfoTab
  },
  data() {
    return {
      dialog: true,
      tab: "",
      productItemSaved: false,
      selectedScheme: null,
      availableSchemes: {},
      applicableSchemes: [],
      positionToAddScheme: 2,
      maximize: false
      // Main Tab
      // EPCG Tab
      // Drawback Tab
      // Cess Tab
      // Quota Tab
      // Ar4 Details Tab
      // Re-export Tab
      // Other Details Tab
    };
  },
  props: {
    maxWidth: {
      type: String,
      default: "450"
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    },
    itemSrNo: {
      type: Number,
      default: 1
    },
    isNewItem: {
      type: Boolean,
      default: false
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    initializeAvailableSchemes() {
      return {
        ...{
          dbk: {
            applicable: false,
            title: "DBK",
            id: 1
          },
          epcg: {
            applicable: false,
            title: "EPCG",
            id: 2
          },
          depb: {
            applicable: false,
            title: "DEPB",
            id: 3
          },
          deec: {
            applicable: false,
            title: "DEEC",
            id: 4
          },
          dfia: {
            applicable: false,
            title: "DFIA",
            id: 5
          }
        }
      };
    },
    isTabDisplay() {
      return (this.isNewItem && this.productItemSaved) || !this.isNewItem;
    },
    resetValuesForSettingEximScheme() {
      this.availableSchemes = this.initializeAvailableSchemes();
      this.applicableSchemes = [];
      this.positionToAddScheme = 2;
    },
    resetTabHeaders() {
      var index = this.tabHeaders.length;
      while (index--) {
        //   [deec] === undefined
        const schemeTitle = this.tabHeaders[index].toLowerCase();
        if (this.availableSchemes[schemeTitle] !== undefined) {
          this.tabHeaders.splice(index, 1);
        }
      }
    },
    selectedEximScheme(scheme) {
      this.resetValuesForSettingEximScheme();
      this.resetTabHeaders();
      this.selectedScheme = scheme;
      scheme.applicableExpSchemes.split(",").forEach(scheme => {
        scheme = scheme.toLowerCase();
        if (this.availableSchemes[scheme] !== undefined) {
          const applicableScheme = { ...this.availableSchemes[scheme] };
          applicableScheme.applicable = true;
          this.tabHeaders.includes(applicableScheme.title)
            ? null
            : this.tabHeaders.splice(this.positionToAddScheme++, 0, applicableScheme.title);
          this.applicableSchemes.push(applicableScheme);
        }
        return scheme;
      });
    },
    changeTab(val) {
      this.tab = val;
    },
    closeDialog() {
      this.$emit("close-product-modal", false);
    }
  },
  computed: {
    generalTabs() {
      //   return ["Products", "Main", "CESS", "Quota", "AR4 Details", "Re-Export", "Other Info"];
      return ["Products", "Main", "AR4 Details", "Other Info"];
    },
    tabHeaders() {
      const allTabs = this.generalTabs;
      const productsTabs = ["Products"];
      if (this.isTabDisplay()) {
        return allTabs;
      } else if (!this.isNewItem) {
        return allTabs;
      }
      return productsTabs;
    }
  }
};
</script>
<style lang="scss">
@import "../../../../../../../styles/settings/index";

.add-product-modal {
  &__tab {
    .v-tabs {
      padding: 0 0.5rem;
      .v-item-group.v-tabs-bar {
        background: transparent;
        .v-slide-group__wrapper {
          .v-tabs-slider-wrapper {
            height: 5px !important;
          }
          .v-tab {
            color: $brand-dark-grey;
          }
          .v-tab.v-tab--active {
            color: black;
          }
        }
      }
    }
    .theme--light.v-item-group.v-tabs-items {
      background: $brand-lightest-grey;
      border: solid 2px $brand-dark-grey;
      border-radius: 5px;
      .theme--light.v-card {
        background: transparent;
      }
    }
  }
}
</style>
